var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNovaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 969.5 496.6",
    style: {
      enableBackground: "new 0 0 969.5 496.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,428.6l39.9-11.9c3.5,28.2,26.3,43.1,53.7,43.1c26.8,0,44.8-12.4,44.8-34.5c0-13.9-6.6-23.6-27.1-27.9 l-45.8-9c-41.2-8.1-55.9-33.1-55.9-61.8c0-40.4,33.3-69.5,81.9-69.5c45.1,0,78.9,24.7,87.6,61.9l-40.4,11.6 c-4.1-23.4-21.4-36.7-47.2-36.7c-24.5,0-39.4,12.4-39.4,30.9c0,12,6,21.9,25,25.8l48,9.3c41,8.1,57,32.5,57,63.2 c0,45.1-34.5,73.5-88.5,73.5C44,496.5,7.9,470.2,0,428.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.9,260.6h88.4c54.6,0,83.1,26.9,83.1,72.8s-28.5,72.2-83.1,72.2h-46.1V493h-42.3L201.9,260.6L201.9,260.6 z M330,333.4c0-23.8-13.5-36.3-39.4-36.3h-46.4v72.7h46.4C316.5,369.8,330,357.3,330,333.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.2,260.6h41.3L565.6,493h-45.1l-19.8-51h-98.3l-19.5,51h-44.3L431.2,260.6z M428.4,406.6h46.4 c4.1,0,8.2,0,13.3,0.6c-2.1-4.4-3.8-8.4-5.2-12.4l-21.1-54c-4.9-12.7-7.4-20.3-10.3-32.6c-2.9,12.4-5.5,20-10.3,32.6l-20.9,54 c-1.4,4-3,7.8-5.2,12.4C420.1,406.6,424.3,406.6,428.4,406.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M553.3,376.8c0-70,44.5-119.7,114.6-119.7c55.7,0,94.8,31.7,108.6,79.6l-42.4,12.2 c-7.9-32.1-31.7-53.5-66.2-53.5c-43.7,0-70.3,34.2-70.3,81.4s26.6,81.4,70.3,81.4c34,0,57.5-20.7,65.9-52.1l44,5.2 c-12,51.1-52.1,85.2-109.9,85.2C598,496.5,553.3,446.6,553.3,376.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M798.8,260.6h163.7v36.6H841.1V357h105.5v36.4H841.1v63h128.4V493H798.8V260.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.8,239.5c66.1,0,119.7-53.6,119.7-119.7S416.9,0,350.8,0S231.1,53.6,231.1,119.7 C231.1,185.9,284.7,239.5,350.8,239.5z M299.7,67.6c39.8-40.6,97.1-54,126.2-24.4c29,29.6,15.8,88-24,128.6s-97.1,54-126.2,24.4 C246.7,166.6,259.9,108.2,299.7,67.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.1,3.5h40.2l95.6,140.9c6.3,9.5,11.2,17.1,17.7,31.7c-1.7-16-1.7-25.7-1.7-35.9L172.6,3.6h40.9V236h-40.2 L77.8,95c-6.5-9.7-11.4-17.3-17.7-31.8c1.7,16.2,1.7,25.8,1.7,35.9L62,235.9H21.2L21.1,3.5L21.1,3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M456.1,3.5h44.7l52.7,145.8c4.7,12.8,7.6,22,10.6,36.4c3-14.4,6-23.6,10.4-36.4L626.9,3.5h43.7l-86.3,232.4 h-41.5L456.1,3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M701,3.5h41.3l93.1,232.4h-45.1l-19.8-51h-98.3l-19.5,51h-44.3L701,3.5z M698.2,149.5h46.4 c4.1,0,8.2,0,13.3,0.6c-2.1-4.4-3.8-8.4-5.2-12.4l-21.1-54c-4.9-12.7-7.4-20.3-10.3-32.6c-2.9,12.4-5.5,20-10.3,32.6l-20.9,54 c-1.4,4-3,7.8-5.2,12.4C689.9,149.5,694.1,149.5,698.2,149.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovaLogo);
export default __webpack_public_path__ + "static/media/nova-logo.7729bce43584eec0951bf42a5c248add.svg";
export { ForwardRef as ReactComponent };